import { render } from "./RoomSearchInput.vue?vue&type=template&id=5acbefcf&ts=true"
import script from "./RoomSearchInput.vue?vue&type=script&lang=ts"
export * from "./RoomSearchInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn});
